export async function setLocalStorageWithExpiry(key, value, time) {
  const now = new Date();
  const expiryInMinutes = time * 1000 * 60;
  const item = { value, expiry: now.getTime() + expiryInMinutes };
  localStorage.setItem(key, JSON.stringify(item));
}

export async function getFromLocalstorage(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}



// WEBPACK FOOTER //
// ./src/services/LocalstorageService.js